import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsAdvancedMultiSelectModule } from '@lcs/shared/advanced-multi-select';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsMultiSelectModule } from '@lcs/shared/multi-select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { LcsChipMultiSelectModule } from 'src/app/common-components/multi-select/multi-select.module';
import { AddExistingPromptModule } from '../add-existing-prompt/add-existing-prompt.module';
import { AddFindMeFollowMeStepModule } from '../add-find-me-follow-me-step/add-find-me-follow-me-step.module';
import { AddPromptModule } from '../add-prompt/add-prompt.module';
import { AddTimeBasedRouteModule } from '../add-time-based-route/add-time-based-route.module';
import { ExtensionGroupDetailModule } from '../extension-group-details/extension-group-detail.module';
import { AddExtensionGroupComponent } from './containers/add-extension-group.component';
import { AddExtensionGroupEffects } from './state/add-extension-group.effects';
import * as fromAddExtensionGroup from './state/add-extension-group.reducer';
import { AddExtensionGroupViewComponent } from './views/add-extension-group-view.component';

@NgModule({
   declarations: [AddExtensionGroupComponent, AddExtensionGroupViewComponent],
   imports: [
      CommonModule,
      FormsModule,
      LcsMultiSelectModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      MatInputModule,
      MatButtonModule,
      MatTooltipModule,
      MatSelectModule,
      MatDialogModule,
      ScrollingModule,
      LcsAdvancedMultiSelectModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      LcsChipMultiSelectModule,
      MatIconModule,
      AddExistingPromptModule,
      AddTimeBasedRouteModule,
      AddFindMeFollowMeStepModule,
      AddPromptModule,
      EntitySelectModule,
      StoreModule.forFeature(fromAddExtensionGroup.addExtensionGroupFeatureKey, fromAddExtensionGroup.reducer),
      EffectsModule.forFeature([AddExtensionGroupEffects]),
      ExtensionGroupDetailModule,
   ],
})
export class AddExtensionGroupModule {}
